// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SPFUX","footer":"styles_footer__15Ks4","passCodeTooltip":"styles_passCodeTooltip__12Ydc"};